import { render, staticRenderFns } from "./Group47.vue?vue&type=template&id=6a938971&scoped=true"
import script from "./Group47.vue?vue&type=script&lang=js"
export * from "./Group47.vue?vue&type=script&lang=js"
import style0 from "./Group47.vue?vue&type=style&index=0&id=6a938971&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a938971",
  null
  
)

export default component.exports